import { Component, OnInit } from '@angular/core';

@Component({
  selector: 'app-foodprepsteps',
  templateUrl: './foodprepsteps.component.html',
  styleUrls: ['./foodprepsteps.component.css']
})
export class FoodprepstepsComponent implements OnInit {

  constructor() { }

  ngOnInit() {
  }

}
